import { render, staticRenderFns } from "./SubLogin.vue?vue&type=template&id=681765d6&scoped=true&"
import script from "./SubLogin.vue?vue&type=script&lang=js&"
export * from "./SubLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681765d6",
  null
  
)

export default component.exports